
const logout = async () => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", localStorage.getItem("token"));
    
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      redirect: 'follow'
    };
    
    return fetch(`${process.env.REACT_APP_API_URL}/invalidate_token`, requestOptions)
      .then(response => response.status)
      .catch(error => console.log('error', error));
}

export default logout